export const _login_user = (user) => ({
  type: 'LOGIN_SUCCESS',
  user
});

export const _set_login_required = (value) => ({
  type: 'SET_LOGIN_REQUIRED',
  value
});

export const _set_i_user = (user) => ({
  type: 'SET_I_SUCCESS',
  user
});

export const _set_user_info = (user) => ({
  type: 'SET_I_SUCCESS',
  user
});

export const _logout_user = () => ({
  type: 'LOGOUT_SUCCESS'
});

export const _set_discount_fake = (data) => ({
  type: 'SET_DISCOUNT_CODE',
  data
});

export const _set_store = (province_id, city_id, store_id, province_name, city_name) => ({
  type: 'STORE_SUCCESS',
  city_id,
  store_id,
  city_name,
  province_id,
  province_name
});

export const _edit_user = (user) => ({
  type: 'USER_EDIT_SUCCESS',
  user
});

export const _init_state = () => ({
  type: 'INIT_STATE'
});

export const _set_cart_data = (cart_credit, cart_data) => ({
  type: 'SET_CART_DATA',
  cart_credit,
  cart_data
});

export const _set_product_id = (product_id, category_id) => ({
  type: 'SET_PRODUCT_ID',
  product_id,
  category_id: parseInt(category_id, 10)
});

export const _save_category_id = (id) => ({
  type: 'SAVE_CATEGORY_ID',
  id: parseInt(id, 10)
});

export const _set_catg_id = (catg_id, catg_name) => ({
  type: 'SET_CATG',
  catg_id: parseInt(catg_id, 10),
  catg_name
});

export const _set_catg_routes = (c1, c2, c3, c4, c5, c6) => ({
  type: 'SET_CATG_ROUTES',
  c1,
  c2,
  c3,
  c4,
  c5,
  c6
});
